module.exports = __webpack_public_path__ + "img/10.ee939da3.jpg";